import React, { useRef, useEffect } from 'react';
var VeltCommentDialogStatusDropdown = function (props) {
    var annotationId = props.annotationId, defaultCondition = props.defaultCondition, inlineCommentSectionMode = props.inlineCommentSectionMode, disabled = props.disabled, onChangeStatus = props.onChangeStatus, children = props.children;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current && onChangeStatus) {
            var element_1 = ref.current;
            var handleChangeStatus_1 = function (event) {
                onChangeStatus(event.detail);
            };
            element_1.addEventListener('changeStatus', handleChangeStatus_1);
            return function () {
                element_1.removeEventListener('changeStatus', handleChangeStatus_1);
            };
        }
    }, [onChangeStatus]);
    return (React.createElement("velt-comment-dialog-status-dropdown", { ref: ref, "annotation-id": annotationId, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "inline-comment-section-mode": [true, false].includes(inlineCommentSectionMode) ? (inlineCommentSectionMode ? 'true' : 'false') : undefined, disabled: [true, false].includes(disabled) ? (disabled ? 'true' : 'false') : undefined }, children));
};
export default VeltCommentDialogStatusDropdown;
